import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  header: {
    height: '30px',
    marginBottom: '0.75rem',
  },
  fareItem: {
    height: '100px',
    marginBottom: '0.5rem',
  },

  map: {
    height: '425px',
    marginBottom: '0.5rem',
  },
};

const SkeletonBusDirectoryMap = (props) => {
  const [className, style] = useStyles(props);

  const { header, fareItem, map } = styles;
  return (
    <Box
      className={`${className} ${SkeletonBusDirectoryMap.componentName} fr-skeleton`}
      style={style}
    >
      <Row gutters>
        <Col xs="4">
          <Box className="fr-skeleton-element" style={header} />
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-element" style={header} />
        </Col>
      </Row>
      <Row gutters>
        <Col xs="4">
          <Row gutters>
            <Col>
              <Box className="fr-skeleton-element" style={fareItem} />
            </Col>
          </Row>
          <Row gutters>
            <Col>
              <Box className="fr-skeleton-element" style={fareItem} />
            </Col>
          </Row>
          <Row gutters>
            <Col>
              <Box className="fr-skeleton-element" style={fareItem} />
            </Col>
          </Row>
          <Row gutters>
            <Col>
              <Box className="fr-skeleton-element" style={fareItem} />
            </Col>
          </Row>
        </Col>
        <Col xs="8">
          <Box className="fr-skeleton-element" style={map} />
        </Col>
      </Row>
      <Row gutters>
        <Col xs="5">
          <Box className="fr-skeleton-element" style={header} />
        </Col>
      </Row>
    </Box>
  );
};

SkeletonBusDirectoryMap.componentName = 'SkeletonBusDirectoryMap';

export default SkeletonBusDirectoryMap;
